import React from 'react';
import { RetailCategoryCards } from '../retail/RetailCategoryCards';

var Upsell = function Upsell(props) {
  var _props$fields = props.fields,
      fields = _props$fields === void 0 ? {} : _props$fields,
      _props$layout = props.layout,
      proplayout = _props$layout === void 0 ? {} : _props$layout;
  var _fields$items = fields.items,
      items = _fields$items === void 0 ? {} : _fields$items;
  var _items$categories = items.categories,
      categories = _items$categories === void 0 ? [] : _items$categories;
  return categories.length ? /*#__PURE__*/React.createElement("div", {
    className: "cb-upsell"
  }, /*#__PURE__*/React.createElement(RetailCategoryCards, props)) : null;
};

export { Upsell };